export default __webpack_public_path__ + "static/media/windows.75e9393a.png";